<template>
  <CockpitDialog
    :title="getDialogTitle"
    :top="'150px'"
    :left="'500px'"
    :width="'1000px'"
    :height="'600px'"
    @close="close"
  >
    <div class="w-full h-full">
      <robot-player
        :cameraInfo="cameraInfo"
        :isDialog="true"
      ></robot-player>
    </div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import RobotPlayer from './h5Player'

export default {
  name: 'TaskDetailDialog',
  components: {
    CockpitDialog,
    RobotPlayer,
  },
  props: {
    cameraInfo: {
      type: Object,
      default: () => {
        return {}
      },
      require: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
  computed: {
    getDialogTitle() {
      if (!this.cameraInfo.robotName && !this.cameraInfo.cameraName) {
        return '监控详情'
      }
      return `${this.cameraInfo.robotName} ${this.cameraInfo.cameraName}`
    },
  },
  created() {},
}
</script>
